/**
 * @namespace OnsiteSurvey
 * @aka SWRNEU.OnsiteSurvey
 */
SWRNEU.OnsiteSurvey = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'onsiteSurvey';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  const DELAY = 20000; // nach wie viel Millisekunden das Popup angezeigt wird
  const MINIMUM_SCROLL_PERCENT = 25; // benötigte Scrolltiefe um das Popup anzuzeigen (Prozent)
  const DAYS = 90; // Wie viel Tage gespeichert wird, dass der User das Popup bereits gesehen hat
  const START_DATE = new Date('2026-09-21T10:00:00'); // Beginn des Aktionszeitraums in dem das Popup angezeigt werden kann
  const END_DATE = new Date('2026-10-18T23:59:59'); // Ende des Aktionszeitraums in dem das Popup angezeigt werden kann
  const TARGET_BASE_URL = "https://response.questback.com/dynamic/www/wdpvrr2pto/answer?sid=TIgt5Ggfvu&Bereich%20Website=";

  const OVERLAY_HTML = '' +
    '<p>Helfen Sie mit, unser Online-Angebot zu verbessern!</p>' +
    '<p>Wir möchten Sie herzlich zu einer Befragung einladen, diese dauert ca. 10 Minuten. Selbstverständlich erheben wir die Daten für diese Umfrage anonym und in Übereinstimmung mit den geltenden <a href="https://www.swr.de/datenschutz/index.html" target="_blank">Datenschutzbestimmungen</a>.</p>' +
    '<p>Vorab herzlichen Dank! Ihr SWR Team</p>' +
    '<button class="btn btn-secondary" data-dialog-close="true">Nicht teilnehmen</button>' +
    '<a class="btn btn-primary" target="_blank" rel="noreferrer nofollow" href="{targetUrl}" data-dialog-close="true">' +
    '  Zur Umfrage' +
    '</a>';

  const onsiteSurveyData = [
    {
      // SWR.de Homepage (Einzelseite!)
      name: "swr-homepage",
      targetUrl: TARGET_BASE_URL + "Homepage",
      probabilityToShowPopup: 1 / 40,
    },
    {
      // SWR Aktuell ink. Unterseiten
      name: "swr-aktuell",
      targetUrl: TARGET_BASE_URL + "SWRAktuell",
      probabilityToShowPopup: 1 / 200,
    },
    {
      // SWR1 (inkl. Unterseiten)
      name: "swr1",
      targetUrl: TARGET_BASE_URL + "SWR1",
      probabilityToShowPopup: 1 / 100,
    },
    {
      // SWRKultur (inkl. Unterseiten)
      name: "swrkultur",
      targetUrl: TARGET_BASE_URL + "SWRKultur",
      probabilityToShowPopup: 1 / 10,
    },
    {
      // SWR Kultur
      name: "kultur",
      targetUrl: TARGET_BASE_URL + "Kultur",
      probabilityToShowPopup: 1 / 10,
    },
    {
      // Sport
      name: "sport",
      targetUrl: TARGET_BASE_URL + "Sport",
      probabilityToShowPopup: 1 / 8,
    },
    {
      // Leben
      name: "leben",
      targetUrl: TARGET_BASE_URL + "Leben",
      probabilityToShowPopup: 1 / 20,
    },
  ];

  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };

  function isInDateRange () {
    const now = Date.now();
    return now >= START_DATE && now <= END_DATE;
  }

  function randomCheckPassed (probabilityToShowPopup) {
    const random = Math.random();
    console.log("OnsiteSurvey: Zufallszahl" + random, ", Wahrscheinlichkeit: " + probabilityToShowPopup, random <= probabilityToShowPopup);
    return random <= probabilityToShowPopup;
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var OnsiteSurvey = function () {

    function OnsiteSurvey (element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.overlayData = {};
      self.$dialog = null;
      self.timeoutId = 0;

      if (COMMON.Browser.isBot) {
        console.log('OnsiteSurvey-PopUp should not be displayed');
        return;
      }

      init();

      $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
        init();
      });

      $(document).on('pjax:beforeReplace', function () {
        self.overlayData = {};

        if(self.$dialog !== null) {
          self.$dialog.remove();
        }

        self.$dialog = null;
        clearTimeout(self.timeoutId);
      });

      function init() {
        /****
         Zu Testzwecken kann per URL-Parameter ein Overlay angezeigt werden:
         showOnsiteSurvey=true -> sorgt dafür, dass ein Overlay angezeigt wird
         overlayIndex=0 -> das Overlay für die SWR-Startseite soll angezeigt werden
         overlayIndex=1 -> das Overlay für SWR Aktuell soll angezeigt werden
         ...
         ignoreRandom=true -> sorgt dafür, dass das Overlay angezeigt wird, ohne, dass
         der Zufallsfaktor eine Rolle spielt.
         */
        var searchParameter = window.location.search;
        var customRequest = (searchParameter.indexOf('showOnsiteSurvey=true') !== -1);
        var hasOverlayIndex = (searchParameter.indexOf('overlayIndex') !== -1);
        var hasIgnoreRandom = (searchParameter.indexOf('ignoreRandom=true') !== -1);
        var overlayIndex = 2;
        const inStorage = COMMON.Storage.local.getItem('onsitebefragung.overlay.uxbefragung');

        if (!isInDateRange() && !customRequest) {
          console.debug('OnsiteSurvey: außerhalb des Aktionszeitraums');
          return;
        }

        if (inStorage !== undefined && inStorage !== null && !customRequest) {
          console.debug('OnsiteSurvey: Popup wurde diesem User bereits angezeigt');
          return;
        }

        if (hasOverlayIndex) {
          var start = searchParameter.indexOf('overlayIndex') + 13;
          overlayIndex = searchParameter.substring(start, start + 1);
        }

        if(customRequest) {
          self.overlayData = onsiteSurveyData[overlayIndex];
        } else {
          self._initOverlay();
        }

        console.log(self.overlayData);

        if(self.overlayData) {
          if(!hasIgnoreRandom) {
            if (window.isFractal) {
              //In Fractal soll eine Wahrscheinlichkeit von 50% gelten.
              self.overlayData.probabilityToShowPopup = 1 / 2;
            }

            if (!randomCheckPassed(self.overlayData.probabilityToShowPopup)) {
              console.debug('OnsiteSurvey: Popup soll laut Wahrscheinlichkeitsberechnung nicht angezeigt werden');
              return;
            }
          }

          self._createOverlay();
        }
      }
    }

    OnsiteSurvey.prototype._initOverlay = function _initOverlay () {
      var self = this;

      if ($.isEmptyObject(self.overlayData)) {
        if (window.location.href === 'https://www.swr.de/' || window.location.href === 'https://www.swr.de/index.html' || window.location.href === 'https://www.swr.de/swr-de-homepage-100.html') {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'swr-homepage');

        } else if (window.location.pathname.indexOf('/swraktuell/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'swr-aktuell');

        } else if (window.location.pathname.indexOf('/swr4/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'swr4');

        } else if (window.location.pathname.indexOf('/swr1/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'swr1');

        } else if (window.location.pathname.indexOf('/swrkultur/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'swrkultur');

        }else if (window.location.pathname.indexOf('/kultur/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'kultur');

        } else if (window.location.pathname.indexOf('/sport/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'sport');

        } else if (window.location.pathname.indexOf('/leben/') !== -1) {
          self.overlayData = onsiteSurveyData.find((element) => element.name === 'leben');

        } else {
          console.debug(`onsiteSurvey: auf dieser Seite wird kein Popup gezeigt`);
          self.overlayData = null;
        }
      }
    };

    OnsiteSurvey.prototype._createOverlay = function _createOverlay () {
      const self = this;
      var id = COMMON.Utils.uuid();
      var header = 'Haben Sie ein paar Minuten?';
      var body = COMMON.Utils.template(OVERLAY_HTML, {
        targetUrl: self.overlayData.targetUrl
      });

      self.$dialog = $(SWRNEU.Dialog.createDialog(id, header, body));
      self.$element.append(self.$dialog);
      console.log("OnsiteSurvey: " + self.$dialog);
      SWRNEU.Dialog.addEventHandler(self.$dialog);

      self._bindEvents();
    };

    /*******
     * Das Absenden des Formulars geschieht per JS.
     * Es werden Daten an das Newsletter-Servelet gesendet.
     * @private
     */
    OnsiteSurvey.prototype._bindEvents = function _bindEvents () {
      var self = this;

      self.timeoutId = setTimeout(function () {
        self.$dialog.trigger('swr:dialog:open');

        //Event Listener sofort entfernen!
        //Das Popup ist offen, wir müssen nicht mehr prüfen.
        $(document).off('swr:scroll:scrolled' + EVENT_KEY, hasScrolled);
      }, DELAY);

      //Ermittlung der Scrolltiefe
      $(document).on('swr:scroll:scrolled' + EVENT_KEY, (event, data) => hasScrolled(data));

      function hasScrolled (data) {
        const scrollTop = data.position;

        // Berechnung der Dokumentenhöhe
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        // Division durch 0 verhindern
        if (docHeight <= 0) {
          return;
        }

        const scrollPercent = (scrollTop / docHeight) * 100;

        if (scrollPercent > MINIMUM_SCROLL_PERCENT) {
          console.debug('OnsiteSurvey Scroll Minimum erreicht');
          self.$dialog.trigger('swr:dialog:open');

          //Event Listener sofort entfernen!
          //Das Popup ist offen, wir müssen nicht mehr prüfen.
          $(document).off('swr:scroll:scrolled' + EVENT_KEY, hasScrolled);
        }
      }

      //Dialogfenster wird geschlossen
      self.$dialog.on('swr:dialog:close', function () {
        //Es soll gespeichert werden, wenn der Nutzer das Overlay geschlossen hat.
        const expires = new Date();

        if (window.isFractal) {
          expires.setTime(expires.getTime());
        } else {
          expires.setTime(expires.getTime() + DAYS * 24 * 60 * 60 * 1000);
        }

        COMMON.Storage.local.setItem('onsitebefragung.overlay.uxbefragung', true, expires);

        self.$dialog.remove();
      });
    };

    // public
    OnsiteSurvey.prototype.dispose = function dispose () {
      this.$element.off(EVENT_KEY);
      clearTimeout(this.timeoutId);

      this.$element = null;
      this.element = null;
      this.$dialog.remove();

      $(document).off(EVENT_KEY);
    };

    // static
    OnsiteSurvey._jQueryInterface = function _jQueryInterface () {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data || data.isEmptyObject()) {
          data = new OnsiteSurvey(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return OnsiteSurvey;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  OnsiteSurvey._jQueryInterface.call($('body'));

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = OnsiteSurvey._jQueryInterface;
  $.fn[NAME].Constructor = OnsiteSurvey;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return OnsiteSurvey._jQueryInterface;
  };

  return OnsiteSurvey;

})(window.jQuery);
